import { render } from "./AboutUs.vue?vue&type=template&id=5c4aae84&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=5c4aae84&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c4aae84"

export default script